import type React from 'react';

import dynamic from 'next/dynamic';

import type { IStepperStep } from './Stepper';

export { useStepper } from './useStepper';

const Stepper = dynamic(() => import('./Stepper'), { ssr: false });

export default Stepper;

export function createStep<T extends React.ComponentType<any>>(
  id: string | number,
  component: T,
  componentProps: Omit<React.ComponentProps<T>, 'form'>
): IStepperStep<T> {
  return { id, component, componentProps };
}
